import { useTranslation } from 'react-i18next';
import { DownloadOutlined, DownOutlined, ExportOutlined, ImportOutlined, PlusOutlined, SearchOutlined } from "@ant-design/icons";
import { Button, Col, Dropdown, message, Row, TableColumnType, Typography } from 'antd';
import { isEmpty } from 'lodash';
import { ChangeEvent, FunctionComponent, KeyboardEvent, useState } from 'react';
import FormInput from "../../../../components/form-input/FormInput";
import ExportAccountModal from '../../../../components/modal/export-account';
import { Permission } from '../../../../layout/sidebar/permission.enum';
import { exportExcelDataTeacher } from '../../../../service/list-account-teachers/listAccountTeachersApi';
import { globalStore } from '../../../../stores/stores';
import { DataType } from "../../../../types/listUsers";
import './filter-table.scss';
import { MenuProps } from "antd/lib";

type FilterTableProps = {
  handleOpen: () => void,
  handleOpenImport: () => void,
  searchValue: string,
  handleChangeInput: (e: ChangeEvent<HTMLInputElement>) => void,
  handleSearch: (e: KeyboardEvent<HTMLSpanElement>) => void,
  handleSubmitSearch: () => void,
  handleOpenFilter: () => void,
  checkedList: Array<string>,
  setCheckedList: (value: string[]) => void,
  dataColumns: TableColumnType<DataType>[]
}


const FilterTable: FunctionComponent<FilterTableProps> = ({
  handleOpen,
  searchValue,
  handleChangeInput,
  handleSearch,
  handleSubmitSearch,
  handleOpenFilter,
  handleOpenImport

}) => {
  const { t } = useTranslation();
  const [openModal, setOpenModal] = useState<boolean>(false);
  const { personalInfo } = globalStore();
  const permissions = personalInfo?.permissions;


  const [filterData, setFilterData] = useState<any>({
    approvedDate: null,
  });


  const handleOk = () => {
    message.success(t("Kết xuất thành công", "Kết xuất thành công"))
    setOpenModal(false)
  }

  const handleChangeFilter = (value: any, name: string) => {
    setFilterData({ ...filterData, [name]: value });
  };

  const exportExcel = async (value: any) => {
    console.log(value);
    
    const data = {
      page: 1,
      size: 10000,
      createdFromDate: !isEmpty(filterData.approvedDate) && !isEmpty(filterData.approvedDate?.[0]) ? `${filterData.approvedDate?.[0]}T00:00:00.000Z` : null,
      createdToDate: !isEmpty(filterData.approvedDate) && !isEmpty(filterData.approvedDate?.[1]) ? `${filterData.approvedDate?.[1]}T00:00:00.000Z` : null,
      status: value.status === 1 ? false : value.status === 2 ? true : null
    };
    await exportExcelDataTeacher(data).then((res) => {
      if (res.status === 200) {
        const fileData = res.data;

        const blob = new Blob([fileData], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const downloadLink = document.createElement("a");
        downloadLink.href = URL.createObjectURL(blob);

        downloadLink.download = `${t("Kết xuất tài khoản Giảng viên", "Kết xuất tài khoản Giảng viên")}.xlsx`;

        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
        message.success(t("Tải xuống thành công!", "Tải xuống thành công!"))
      }
    })
  };

  const hasCreatePermission = permissions?.includes(Permission.CreateLecturerAccountUpdate);
  const hasExportPermission = permissions?.includes(Permission.ExportLecturerAccount);

  const items: MenuProps["items"] = [
    {
      label: t("Tạo tài khoản", "Tạo tài khoản"),
      key: "1",
      icon: <PlusOutlined />,
      onClick: handleOpen,
    },
    {
      label: t("Import dữ liệu", "Import dữ liệu"),
      key: "2",
      icon: <ImportOutlined />,
      onClick: handleOpenImport,
    },

  ];

  return (
    <>
      <div className="heading-extra">
        <Row gutter={[{ md: 8, xl: 8, xs: 8 }, 8]}>
          <Col md={{ span: !hasCreatePermission ? 7 : 5 }}
            lg={{ span: !hasCreatePermission ? 7 : 5 }}
            xl={{ span: !hasCreatePermission ? 7 : 5 }}
            xs={{ span: !hasCreatePermission ? 7 : 5 }}
          >
            <div className="heading-filter">
              <Button className="filter-button" onClick={handleOpenFilter}>
                <Typography.Text>{t("Bộ lọc", "Bộ lọc")}</Typography.Text>
                <DownOutlined />
              </Button>
            </div>
          </Col>
          <Col md={{ span: !hasCreatePermission ? 14 : 11 }}
            lg={{ span: !hasCreatePermission ? 14 : 11 }}
            xl={{ span: !hasCreatePermission ? 14 : 11 }}
            xs={{ span: !hasCreatePermission ? 14 : 11 }}
          >
            <div className="heading-search">
              <FormInput placeholder={t("Nhập tên, email để tìm kiếm", "Nhập tên, email để tìm kiếm")} value={searchValue}
                onChange={handleChangeInput}
                onKeyPress={handleSearch}
                afterPrefixIcon={<SearchOutlined onClick={handleSubmitSearch} />} />
            </div>
          </Col>
          {
            hasCreatePermission ?
              <Col >
                <div className="heading-resigter">
                  <Dropdown menu={{ items }} placement="bottomLeft">
                    <Button type="primary">{t("Tuỳ chọn", "Tuỳ chọn")}</Button>
                  </Dropdown>
                </div>
              </Col> : null
          }
          {
            hasExportPermission ?
              <Col md={{ span: 3 }}
                lg={{ span: 3 }}
                xl={{ span: 3 }}
                xs={{ span: 3 }}
              >
                <div className="heading-resigter">
                  <Button className="btn" onClick={() => setOpenModal(true)}>
                    <DownloadOutlined />
                  </Button>
                </div>
              </Col> : null
          }
        </Row>
      </div>

      <ExportAccountModal
        open={openModal}
        handleClose={() => setOpenModal(false)}
        title={t("Kết xuất tài khoản Giảng viên", "Kết xuất tài khoản Giảng viên")}
        handleOk={handleOk}
        filterData={filterData}
        setFilterData={handleChangeFilter}
        exportExcel={exportExcel}
      />
    </>
  );
};

export default FilterTable;
